import { useQuery } from "relay-hooks";
import { graphql } from "babel-plugin-relay/macro";
import { pronounceFeedbackQuery } from "./__generated__/pronounceFeedbackQuery.graphql";
import { useDeviceLang } from "hooks/deviceHooks";

const PronounceFeedbackQuery = graphql`
  query pronounceFeedbackQuery($text: String!, $audio: String!, $language: String!, $responseLanguage: String!) {
    pronounceFeedback(text: $text, audio: $audio, language: $language, responseLanguage: $responseLanguage) {
      score
      feedback
      letter_analysis {
        letter
        score
      }
      method
      transcript
      remainingTries
    }
  }
`;

export const usePronounceFeedback = (
  text: string | undefined,
  audio: string | undefined,
  language: string | undefined,
  { skip }: { skip?: boolean } = { skip: false }
) => {
  const { appLang } = useDeviceLang();

  const shouldSkip = skip === true || !text || !audio || !language;
  const { data, error, isLoading } = useQuery<pronounceFeedbackQuery>(
    PronounceFeedbackQuery,
    { text: text || "", audio: audio || "", language: language || "", responseLanguage: appLang || "en" },
    { skip: shouldSkip }
  );

  return {
    feedback: shouldSkip ? undefined : data?.pronounceFeedback,
    error,
    isLoading
  };
};
